module.exports = __webpack_public_path__ + "static/productivity_app_cover-7d1c524200bba1b647248be1a0ade601.png";